module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [(_vm.notFound) ? _c('not-found') : [_c('div', {
    staticClass: "steps-bar"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('swiper', {
    ref: "stepSwiper",
    attrs: {
      "options": _vm.swiperOptions
    }
  }, _vm._l((_vm.steps), function(step, key) {
    return _c('swiper-slide', {
      key: key
    }, [_c('div', {
      staticClass: "step",
      class: {
        active: step.route === _vm.$route.name, inactive: _vm.availableSteps !== null && _vm.availableSteps.indexOf(step.route) === -1
      },
      attrs: {
        "name": _vm.getStepName(step.route)
      },
      on: {
        "click": function($event) {
          _vm.goToStep(step.route)
        }
      }
    }, [_c('span', {
      staticClass: "step-number"
    }, [_vm._v(_vm._s(step.id))]), _c('span', {
      staticClass: "step-name"
    }, [_vm._v(_vm._s(_vm.$t('pos.steps.step-name', {
      step: step.route
    })))])])])
  }))], 1)]), (_vm.currentStep.show && !_vm.loading) ? _c('div', {
    staticClass: "step-title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('pos.steps.step-name', {
    step: _vm.currentStep.route
  })))])]) : _vm._e(), _c('div', {
    staticClass: "child",
    class: {
      "content-background": _vm.currentStep.show
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading-container"
  }, [_c('loading')], 1) : [(_vm.error) ? [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.error))])] : _vm._e(), (!_vm.error) ? [_c('router-view', {
    attrs: {
      "campaign": _vm.campaign
    }
  })] : _vm._e()]], 2)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28e56650"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign-wrapper/CampaignWrapper.vue
// module id = 919
// module chunks = 1